import type { CreateTrainingMatrixRevisionEntry, TrainingMatrixPositionRow } from '@/entities/Training';

export function buildTrainingMatrixEntries(
  positions: TrainingMatrixPositionRow[]
): CreateTrainingMatrixRevisionEntry[] {
  return positions
    .map((position) => ({
      positionId: position.id,
      documentRevisionIds: position.documents.map((document) => document.id),
    }))
    .filter((entry) => entry.documentRevisionIds.length > 0);
}
